import QuickFocus from './QuickFocus';
export default QuickFocus;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/index.js